import React from 'react';
import { Audio } from 'react-loader-spinner';

const LoaderOverlay = ({ loading }) => {
  return (
    <React.Fragment>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)', // semi-transparent black overlay
            zIndex: 9999, // ensures the overlay is on top of everything
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
            {/* <div
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: '#fff',
                textAlign: 'center',
                zIndex: 10000, // ensures the loader and text are above the overlay
              }}
            >
              Loading...
            </div> */}
                <div id="preloader">
                <div id="container" className="container-preloader">
                    <div className="animation-preloader">
                    {/* <div class="spinner"></div> */}
                    <div className="txt-loading">
                        <span preloader-text={process.env.REACT_APP_LOADER_LBL1} className="characters">{process.env.REACT_APP_LOADER_LBL1}</span>
                        <span preloader-text={process.env.REACT_APP_LOADER_LBL2} className="characters">{process.env.REACT_APP_LOADER_LBL2}</span>
                        <span preloader-text={process.env.REACT_APP_LOADER_LBL3} className="characters">{process.env.REACT_APP_LOADER_LBL3}</span>
                        <span preloader-text={process.env.REACT_APP_LOADER_LBL4} className="characters">{process.env.REACT_APP_LOADER_LBL4}</span>
                        <span preloader-text={process.env.REACT_APP_LOADER_LBL5} className="characters">{process.env.REACT_APP_LOADER_LBL5}</span>
                        <span preloader-text={process.env.REACT_APP_LOADER_LBL6} className="characters">{process.env.REACT_APP_LOADER_LBL6}</span>
                        <span preloader-text={process.env.REACT_APP_LOADER_LBL7} className="characters">{process.env.REACT_APP_LOADER_LBL7}</span>
                        <span preloader-text={process.env.REACT_APP_LOADER_LBL8} className="characters">{process.env.REACT_APP_LOADER_LBL8}</span>
                    </div>
                    </div>
                    {/* <div class="loader-section section-left"></div>
                    <div class="loader-section section-right"></div> */}
                </div>
                </div>
          <Audio
            visible={true}
            height={80}
            width={80}
            ariaLabel="discuss-loading"
            wrapperStyle={{}}
            wrapperClass="discuss-wrapper"
            color="#cbeceff5"
      
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default LoaderOverlay;